import { createFileRoute } from '@tanstack/react-router';

import { CampaignLinksPage } from '@/features/attribution/pages/campaign-links';

export const Route = createFileRoute('/_app/settings/campaign-links')({
  component: CampaignLinksPage,
});
